import type { DealPromptDomainsConfig } from '@openx/components-deal-prompt/lib/utils/context/type.ts';
import { useDealPromptAppsSearchExtendedFetch } from './utils/useDealPromptAppsSearchExtendedFetch.ts';
import { useDealPromptAppsSearchFetch } from './utils/useDealPromptAppsSearchFetch.ts';
import { useDealPromptAudienceAccountOptions } from './utils/useDealPromptAudienceAccountOptions.ts';
import { useDealPromptAudienceCalculateOrf } from './utils/useDealPromptAudienceCalculateOrf.tsx';
import { useDealPromptAudienceCreateDealSubmit } from './utils/useDealPromptAudienceCreateDealSubmit.ts';
import { useDealPromptAudienceExcelGenerate } from './utils/useDealPromptAudienceExcelGenerate.ts';
import { useDealPromptAudienceExternalPartnerWithData } from './utils/useDealPromptAudienceExternalPartnerWithData.ts';
import { useDealPromptAudienceSearchFetch } from './utils/useDealPromptAudienceSearchFetch.ts';
import { useDealPromptAudienceSearchTextFetch } from './utils/useDealPromptAudienceSearchTextFetch.ts';
import { useDealPromptCountryOptions } from './utils/useDealPromptCountryOptions.ts';
import { useDealPromptDataPartnerOptions } from './utils/useDealPromptDataPartnerOptions.ts';
import { useDealPromptDomainSearchExtendedFetch } from './utils/useDealPromptDomainSearchExtendedFetch.ts';
import { useDealPromptDomainSearchFetch } from './utils/useDealPromptDomainSearchFetch.ts';
import { useDealPromptFilters } from './utils/useDealPromptFilters.ts';
import { useDealPromptLocationOptions } from './utils/useDealPromptLocationOptions.ts';
import { useDealPromptOrganizationsList } from './utils/useDealPromptOrganizationsList.ts';
import { useDealPromptPricing } from './utils/useDealPromptPricing.ts';
import { useDealPromptRegionOptions } from './utils/useDealPromptRegionOptions.ts';
import { useDealPromptTaxonomyMetadataOptions } from './utils/useDealPromptTaxonomyMetadataOptions.ts';

export const dealPromptConfig: DealPromptDomainsConfig = {
  useDealPromptDomainSearchFetch,
  useDealPromptFilters,
  useDealPromptAppsSearchFetch,
  useDealPromptAudienceSearchTextFetch,
  useDealPromptLocationOptions,
  useDealPromptRegionOptions,
  useDealPromptCountryOptions,
  useDealPromptDataPartnerOptions,
  useDealPromptAudienceAccountOptions,
  useDealPromptTaxonomyMetadataOptions,
  useDealPromptAudienceExternalPartnerWithData,
  useDealPromptAudienceExcelGenerate,
  useDealPromptAppsSearchExtendedFetch,
  useDealPromptDomainSearchExtendedFetch,
  useDealPromptAudienceSearchFetch,
  useDealPromptAudienceCalculateOrf,
  useDealPromptPricing,
  useDealPromptOrganizationsList,
  useDealPromptAudienceCreateDealSubmit,
};
